<template>
  <div class="container">
    <van-list :class="{'box-1': showSubAgent}">
      <van-cell>
        <div
          class="row title"
        >
          <span class="item">扣减项目</span>
          <span class="item">来源帐期</span>
          <span class="item">本期扣款金额(元)</span>
        </div>
      </van-cell>
      <template
        v-if="list && list.length"
      >
        <van-cell
          v-for="(item,index) in list"
          :key="index"
        >
          <div class="row">
            <span class="item">{{ item.receivableTypeDesc }}</span>
            <span class="item">{{ item.billMonth }}</span>
            <span class="item">{{ item.receivedAmount | formatAmount }}</span>
          </div>
        </van-cell>
      </template>
      <van-cell
        v-else
        title="暂无数据"
      />
    </van-list>
    <template v-if="showSubAgent">
      <div class="sub-agent">
        下级合作商还款
      </div>
      <van-list>
        <van-cell>
          <div
            class="row title"
          >
            <span class="item">合作商名称</span>
            <span class="item">扣减项目</span>
            <span class="item">来源帐期</span>
            <span class="item">本期扣款金额(元)</span>
          </div>
        </van-cell>
        <template
          v-if="list2 && list2.length"
        >
          <van-cell
            v-for="(item,index) in list2"
            :key="index"
          >
            <div class="row">
              <span class="item">{{ item.partnerName }}</span>
              <span class="item">{{ item.receivableTypeDesc }}</span>
              <span class="item">{{ item.billMonth }}</span>
              <span class="item">{{ item.receivedAmount | formatAmount }}</span>
            </div>
          </van-cell>
        </template>
        <van-cell
          v-else
          title="暂无数据"
        />
      </van-list>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import IndexAnchor from 'vant/lib/index-anchor';

export default {
  name: 'OffsetDetail',
  components: { [IndexAnchor.name]: IndexAnchor },
  computed: {
    ...mapState('billModule', ['currentBilledInfo']),
    list() {
      return this.currentBilledInfo.selfOffsetDetail || [];
    },
    list2() {
      return this.currentBilledInfo.otherOffsetDetail || [];
    },
    showSubAgent() {
      return this.list2.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .box-1 {
    max-height: 80vh;
    overflow: auto;
  }
  .row {
    display: flex;
    background-color: white;
    .item {
      text-align: center;
      flex: 1;
    }

    &.title {
      font-weight: bold;
    }
  }
  .sub-agent {
    margin: 40px 30px 6px;
    font-size: 30px;
    text-align: left;
  }
</style>
